import HeroSection from "../components/HeroSection";
import { useAuthStore } from "../lib/authStore";
import { useNavigate } from "react-router-dom";
import { useResponsive } from "../lib/useResponsive";

export default function LandingPage() {
  const user = useAuthStore((s) => s.user);
  const navigate = useNavigate();
  const { isMobile } = useResponsive();

  return (
    <main>
      <HeroSection />

      {/* CTA band */}
      <div style={{
        ...S.ctaBand,
        flexDirection: isMobile ? "column" : "row",
        textAlign: isMobile ? "center" : "left",
        gap: isMobile ? 12 : 24,
        padding: isMobile ? "16px" : "20px 24px",
      }}>
        <p style={{ ...S.ctaText, margin: 0 }}>
          {user
            ? `Welcome back, ${user.name.split(" ")[0]}. View your portfolio below.`
            : "Already an investor? Log in to view your portfolio and real-time holdings."}
        </p>
        <button
          style={{ ...S.ctaBtn, width: isMobile ? "100%" : "auto" }}
          onClick={() => user ? navigate("/dashboard") : navigate("/login")}
        >
          {user ? "Go to Dashboard →" : "Portal Login →"}
        </button>
      </div>

      <footer style={S.footer}>
        <div style={{
          ...S.footerInner,
          flexDirection: isMobile ? "column" : "row",
          gap: isMobile ? 6 : 24,
          textAlign: isMobile ? "center" : "left",
        }}>
          <span style={{ color: "var(--text-muted)", fontSize: 12 }}>Private Community Investment Fund · Est. Nov 2025</span>
        </div>
      </footer>
    </main>
  );
}

const S: Record<string, React.CSSProperties> = {
  ctaBand: {
    background: "rgba(29,158,117,0.08)",
    borderTop: "1px solid rgba(29,158,117,0.2)",
    borderBottom: "1px solid rgba(29,158,117,0.2)",
    padding: "20px 24px",
    display: "flex", alignItems: "center", justifyContent: "center",
    gap: 24, flexWrap: "wrap",
  },
  ctaText: { fontSize: 14, color: "var(--text-secondary)" },
  ctaBtn: {
    padding: "9px 22px", borderRadius: 8,
    background: "var(--teal-dim)", border: "none",
    color: "#fff", fontSize: 13, fontWeight: 600,
    cursor: "pointer", letterSpacing: "0.02em",
    whiteSpace: "nowrap",
  },
  footer: {
    background: "rgba(0,0,0,0.4)",
    borderTop: "1px solid rgba(255,255,255,0.05)",
    padding: "28px 24px",
  },
  footerInner: {
    maxWidth: 1200, margin: "0 auto",
    display: "flex", alignItems: "center", gap: 24, flexWrap: "wrap",
  },
};
